<div style="gap: 20px; display: grid;">
  <h1>Политика использования файлов куки (cookie)</h1>
  <div>
    <h2>Что такое файлы куки</h2>
    <div>
      Файлы куки (cookie) — это небольшие текстовые файлы, передаваемые веб-сервером на ваш компьютер, мобильный телефон
      или другое устройство, подключенное к Интернету, когда вы посещаете веб-сайт.
    </div>
  </div>
  <div>
    <h2>Как мы используем файлы куки</h2>
    <div>
      Файлы куки используются для обеспечения эффективной и безопасной работы веб-сайта, улучшения пользовательского
      опыта
      посетителей, а также для сохранения пользовательских предпочтений, в том числе при выходе из профиля на
      устройстве.<br>
      Информация, полученная с помощью файлов куки на веб-сайте и не позволяющая идентифицировать конкретного
      пользователя, может быть также использована в маркетинговых целях.
    </div>
  </div>
  <div>
    <h2>Типы файлов куки, которые мы используем, при посещении веб-сайта:</h2>
    <div>
      Сеансовые файлы — сохраняются в браузере до тех пор, пока вы не покинете веб-сайт.<br>
      Постоянные файлы куки — сохраняются в вашем браузере после завершения сеанса.<br>
      Основные куки — файлы куки, которые связаны с основным доменом.<br>
      Сторонние куки — файлы куки из другого домена.<br>
    </div>
  </div>
  <div>
    <h2>Настройки браузера</h2>
    <div>
      Вы можете удалить файлы куки, сохраненные на вашем устройстве.<br>
      Вы также можете отказаться от сохранения файлов куки на вашем устройстве, изменив соответствующие настройки
      браузера.
    </div>
  </div>
  <div>
    <h2>Яндекс Метрика</h2>
    <div>
      Мы используем сервис Яндекс Метрика компании OOO «ЯНДЕКС». («Сервис»), который позволяет собирать и анализировать
      статистику посещения сайтов и поведения посетителей. Это помогает нам лучше понимать потребности и интересы
      посетителей и на основании этих сведений совершенствовать наш сайт.<br>
      Сведения, получаемые с помощью Сервиса, не позволяют идентифицировать конкретных пользователей.
    </div>
  </div>
</div>
